<template>
  <i><slot /></i>
</template>

<script>
export default {
  name: "SbItalic",
  props: {
    blok: {
      type: Object,
      required: false,
    },
  },
};
</script>
